import { gql } from '@apollo/client';

const Avatar = gql`
  fragment Avatar on Image {
    path
    size
  }
`;

export default {
  Avatar,
};
